import {
  Box,
  DialogActions,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { CDN_PATH } from 'src/constants/global'

const BaseDialogFooter = (): JSX.Element => {
  const { palette } = useTheme()

  return (
    <DialogActions sx={{ margin: '12px 24px 12px 24px', padding: '0px', borderTop: `1px solid ${palette.gray4.main}` }}>
      <Box display="flex" width="100%" paddingY="16px">
        <Box display="flex" alignItems="center">
          <Typography variant="body3" fontWeight="regular" paddingRight="4px" color="primary.main">
            Powered by
          </Typography>
          <img src={`${CDN_PATH}/images/sika-logo-green-background.svg`} alt="Sika" />
        </Box>
      </Box>
    </DialogActions>
  )
}

export default BaseDialogFooter
